<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import PRList from "@/components/widgets/pr-list";
import ItemUpdate from "@/router/views/office/office-widgets/update-pr-modal.vue"
import PrintOptions from "@/components/modals/print-options.vue";
import PRNumberModal from "@/components/modals/pr-number.vue";
import TransferCycleModal from "@/components/modals/transfer-cycle-modal.vue";
import MoveCampusModal from "@/components/modals/move-campus-modal.vue";
import PRDescModal from "@/components/modals/pr-desc-modal.vue";
import PrLogs from "@/components/modals/pr-logs.vue";
import ReturnPR from "@/components/modals/return-pr-modal.vue";
import ApprovePR from "@/components/modals/approve-pr-modal.vue";
import AttachmentModal from "@/components/modals/attachment-modal.vue";
import EmployeeModal from '@/components/modals/employee.vue';
import { cloneDeep } from "lodash";
export default {
    page: {
        title: "Manage PR",
    },
    components: {
        Layout,
        PageHeader,
        PRList,
        ItemUpdate,
        PrintOptions,
        PRNumberModal,
        TransferCycleModal,
        PRDescModal,
        PrLogs,
        ReturnPR,
        ApprovePR,
        AttachmentModal,
        EmployeeModal,
        MoveCampusModal,
    },
    data() {
        return {
            title: "Manage PR",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Manage PR",
                    active: true,
                },
            ],
            tabModel: 0,
            pendingPRs: [],
            approvedPRs: [],
            submittedPRs: [],
            cancelledPRs: [],
            managePR: false,
            loading: false,
            selectedPRType: '',
            selectedPRCopy: {},
            selectedPR: {},
            mop: [],
            bacSettings: [],
        };
    },
    watch: {
        async tabModel(newVal){
            this.loading = true;
            if(newVal == 0){
                await this.getPendingPRs(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
            }else if(newVal == 1){
                await this.getApprovedPRs(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
            }else if(newVal == 2){
                await this.getSubmittedPRs(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
            }else if(newVal == 3){
                await this.getCancelledPRs(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
            }
            this.loading = false;
        },
    },
    async created() {
        this.changeData(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
        this.getMOP();
        this.getBacSettings(this.$store.state.data.selectedCampus.id);
        if(this.$store.state.decrypt.isAdmin()){
            this.managePR = true;
        }else{
            let accessList = this.$store.state.decrypt.userAccessList();
            let access = accessList.find((x) => x.Access.toLowerCase() === 'manage pr' && x.Type.toLowerCase() === 'procurement')
            if(access){
                this.managePR = true;
            }else{
                this.managePR = false;
            }
        }
    },
    methods: {
        async getMOP() {
            await this.$store
                .dispatch("modeofprocurement/GetModeOfProcurement")
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.mop = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong - getting mode of procurement", "error");
                });
        },
        async getBacSettings(campusId){
            await this.$store
                .dispatch(
                    "bacsetting/GetBacSetting",
                    campusId
                )
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.bacSettings = res.data;
                })
                .catch(() => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        async changeData(cycle, campusId){
            this.pendingPRs = [];
            this.approvedPRs = [];
            this.submittedPRs = [];
            this.cancelledPRs = [];
            this.loading = true;
            if(this.tabModel == 0){
                await this.getPendingPRs(cycle, campusId);
            }else if(this.tabModel == 1){
                await this.getApprovedPRs(cycle, campusId);
            }else if(this.tabModel == 2){
                await this.getSubmittedPRs(cycle, campusId);
            }else if(this.tabModel == 3){
                await this.getCancelledPRs(cycle, campusId);
            }
            this.loading = false;
        },
        async getPendingPRs(cycle, campusId){
            if(this.pendingPRs.length) return;
            try{
                const {data: response} = await this.$store.dispatch("pr/GetPostedPr", {cycle, campusId});
                if(response.error){
                    return this.showToast(response.errorMessage, 'error');
                }
                response.map((item) => {
                    item.submitted = false;
                    item.modeOfProcurementId = "";
                    item.showPV = false;
                    item.showDetails = false;
                    item.detailLoaded = false;
                    item.loadingDetail = false;
                    item.itemVisible = false;
                    item.attachmentVisible = false;
                    item.addDocu = false;
                    item.attachmentLoading = false;
                    item.fileSearch = "";
                    item.prFiles = [];
                    item.searchKey = `${item.description} ${item.prNumber}`;
                    item.detailVisible = true;
                    item.submitDetail = false;
                    item.memberVisible = false;
                    item.deliveryPeriodStr = item.deliveryPeriod.toString();
                    item.activityVisible = false;
                    item.prItems = [];
                    item.activities = [];
                    item.searchActivity = "";
                    item.activityLoading = false;
                    item.bacResAntiDate = new Date();
                    item.prResolutions = [];
                    item.prResolutionLoading = false;
                    item.unGroupedItems = [];
                });
                this.pendingPRs = response;
            }catch (error){
                this.showToast('An error occurred while fetching pending PRs', 'error');
            }
        },
        async getApprovedPRs(cycle, campusId){
            if(this.approvedPRs.length) return;
            try{
                const {data: response} = await this.$store.dispatch("pr/GetApprovedPr", {cycle, campusId});
                if(response.error){
                    return this.showToast(response.errorMessage, 'error');
                }
                response.map((item) => {
                    item.showDetails = false;
                    item.detailLoaded = false;
                    item.loadingDetail = false;
                    item.itemVisible = false;
                    item.attachmentVisible = false;
                    item.addDocu = false;
                    item.attachmentLoading = false;
                    item.fileSearch = "";
                    item.prFiles = [];
                    item.prItems = [];
                    item.searchKey = `${item.description} ${item.prNumber}`;
                    item.detailVisible = true;
                    item.submitDetail = false;
                    item.memberVisible = false;
                    item.deliveryPeriodStr = item.deliveryPeriod.toString();
                    item.activityVisible = false;
                    item.activities = [];
                    item.searchActivity = "";
                    item.activityLoading = false;
                    item.bacResAntiDate = new Date(item.bacResDate);
                    item.prResolutions = [];
                    item.prResolutionLoading = false;
                    item.unGroupedItems = [];
                });
                this.approvedPRs = response;
            }catch (error){
                this.showToast('An error occurred while fetching approved PRs', 'error');
            }
        },
        async getSubmittedPRs(cycle, campusId){
            if(this.submittedPRs.length) return;
            try{
                const {data: response} = await this.$store.dispatch("pr/GetSubmittedPr", {cycle, campusId});
                if(response.error){
                    return this.showToast(response.errorMessage, 'error');
                }
                response.map((item) => {
                    item.showDetails = false;
                    item.detailLoaded = false;
                    item.loadingDetail = false;
                    item.itemVisible = false;
                    item.attachmentVisible = false;
                    item.addDocu = false;
                    item.attachmentLoading = false;
                    item.fileSearch = "";
                    item.prFiles = [];
                    item.prItems = [];
                    item.searchKey = `${item.description} ${item.prNumber}`;
                    item.detailVisible = true;
                    item.submitDetail = false;
                    item.memberVisible = false;
                    item.deliveryPeriodStr = item.deliveryPeriod.toString();
                    item.activityVisible = false;
                    item.activities = [];
                    item.searchActivity = "";
                    item.activityLoading = false;
                    item.bacResAntiDate = new Date(item.bacResDate);
                    item.prResolutions = [];
                    item.prResolutionLoading = false;
                    item.unGroupedItems = [];
                });
                this.submittedPRs = response;
            }catch (error){
                this.showToast('An error occurred while fetching submitted PRs', 'error');
            }
        },
        async getCancelledPRs(cycle, campusId){
            if(this.cancelledPRs.length) return;
            try{
                const {data: response} = await this.$store.dispatch("pr/GetCancelledPr", {cycle, campusId});
                if(response.error){
                    return this.showToast(response.errorMessage, 'error');
                }
                response.map((item) => {
                    item.showDetails = false;
                    item.detailLoaded = false;
                    item.loadingDetail = false;
                    item.itemVisible = false;
                    item.attachmentVisible = false;
                    item.addDocu = false;
                    item.attachmentLoading = false;
                    item.fileSearch = "";
                    item.prFiles = [];
                    item.prItems = [];
                    item.searchKey = `${item.description} ${item.prNumber}`;
                    item.detailVisible = true;
                    item.submitDetail = false;
                    item.memberVisible = false;
                    item.deliveryPeriodStr = item.deliveryPeriod.toString();
                    item.activityVisible = false;
                    item.activities = [];
                    item.searchActivity = "";
                    item.activityLoading = false;
                    item.bacResAntiDate = new Date(item.bacResDate);
                    item.prResolutions = [];
                    item.prResolutionLoading = false;
                    item.unGroupedItems = [];
                });
                this.cancelledPRs = response;
            }catch (error){
                this.showToast('An error occurred while fetching cancelled PRs', 'error');
            }
        },
        updateResource(data, type, pr){
            this.resourceParentType = type;
            this.resourceParentData = data.parent;
            this.selectedPR = pr;
            let row = {
                id: data.data.apiResourceId,
                itemName: data.data.itemName,
                description: data.data.description,
                unitId: data.data.unitId,
                unitName: data.data.unit,
                itemCategoryId: data.data.itemCategoryId,
                itemCategoryName: data.data.itemCategory,
                apiResourceId: data.data.apiResourceId
            }
            this.$refs.itemUpdate.transferData(row);
            this.$bvModal.show('update-description-modal');
        },
        async updateDescriptionSubmit(modalData){
            let data = cloneDeep(modalData);
            let url = this.resourceParentType === 'pending' ? 'apiresource/UpdatePPMPSomeItem' : 'pritem/UpdateSomePRItem';
            if(this.resourceParentType !== 'pending'){
                data.prId = this.resourceParentData.prId
            }
            this.$store.dispatch(url, data).then(res => {
                if(res.data.error){
                    return this.showToast(res.data.errorMessage, 'error')
                }
                let index = this.resourceParentData.items.findIndex(x => x.apiResourceId == modalData.id);
                this.resourceParentData.items[index].itemName = modalData.itemName;
                this.resourceParentData.items[index].description = modalData.description;
                this.resourceParentData.items[index].unitId = modalData.unitId;
                this.resourceParentData.items[index].unitName = modalData.unitName;
                this.$bvModal.hide('update-description-modal')
                this.showToast('Successfully updated!', 'success')
                if(this.resourceParentData.items[index].itemCategoryId != modalData.itemCategoryId){
                    this.selectedPR.detailLoaded = false;
                    this.getPRItems(this.selectedPR);
                }
            }).catch(err => {
                this.showToast('Something went wrong!', 'error')
            })
        },
        printPR(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Procurement/PR",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        changePRNo(row){
            this.$bvModal.show('pr-number-modal');
            this.$refs.prNumberModal.getPR(row);
            this.selectedPRForChanging = row;
        },
        updatePRNumber(prNumber){
            this.selectedPRForChanging.prNumber = prNumber;
        },
        updatePRDescription(row, type){
            this.selectedPRType = type;
            this.selectedPRCopy = cloneDeep(row);
            this.$refs.prDescModal.updateData({
                id: row.id,
                description: row.description,
                datePosted: row.datePosted,
            });
            this.$bvModal.show('update-pr-description-modal')
        },
        async updatePRDescriptionSubmit(modalData){
            var error = 0;
            if(modalData.description.trim() != this.selectedPRCopy.description.trim()){
                await this.$store.dispatch('pr/UpdatePrDescription', {
                    id: modalData.id,
                    description: modalData.description,
                }).then(res => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error')
                    }
                    if(this.selectedPRType === 'pending'){
                        let index = this.pendingPRs.findIndex(x => x.id === modalData.id)
                        this.pendingPRs[index].description = modalData.description;
                    }else if(this.selectedPRType === 'approved'){
                        let index = this.approvedPRs.findIndex(x => x.id === modalData.id)
                        this.approvedPRs[index].description = modalData.description;
                    }else{
                        let index = this.submittedPRs.findIndex(x => x.id === modalData.id)
                        this.submittedPRs[index].description = modalData.description;
                    }
                }).catch(err => {
                    error++;
                })
            }
            if(this.getDate(modalData.datePosted) != this.getDate(new Date(this.selectedPRCopy.datePosted))){
                await this.$store.dispatch('pr/UpdatePrDate', {
                    id: modalData.id,
                    datePosted: this.getDate(modalData.datePosted),
                }).then(res => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error')
                    }
                }).catch(err => {
                    error++;
                })
            }
            if(error > 0){
                this.showToast('Something went wrong!', 'error')
            }else{
                this.showToast('PR updated!', 'success')
                this.$bvModal.hide('update-pr-description-modal')
            }
        },
        updateCycle(row, type){
            this.selectedPRType = type;
            this.selectedPR = row;
            this.selectedPRCopy = cloneDeep(row);
            this.$refs.transferCycleModal.getData();
            this.$bvModal.show('transfer-cycle-modal');
        },
        transferCycleSubmit(cycle){
            this.$store.dispatch('pr/TransferCycle', {
                id: this.selectedPR.id,
                cycle: cycle,
            }).then(res => {
                if(res.data.error){
                    return this.showToast(res.data.errorMessage, 'error');
                }
                if(this.selectedPRType === 'pending'){
                    let index = this.pendingPRs.findIndex(x => x.id === this.selectedPR.id)
                    this.pendingPRs.splice(index, 1);
                }else if(this.selectedPRType === 'approved'){
                    let index = this.approvedPRs.findIndex(x => x.id === this.selectedPR.id)
                    this.approvedPRs.splice(index, 1);
                }else{
                    let index = this.submittedPRs.findIndex(x => x.id === this.selectedPR.id)
                    this.submittedPRs.splice(index, 1);
                }
                this.showToast('PR transfered!', 'success')
                this.$bvModal.hide('transfer-cycle-modal')
            })
            .catch(err => {
                this.showToast('Something went wrong!', 'error')
            })
        },
        getPRLogs(id){
            this.$refs.prLogs.getData(id);
            this.$bvModal.show("pr-log-modal");
        },
        returnPRFunc(row) {
            this.selectedPRType = 'return';
            this.$refs.returnPR.updateData({
                id: row.id,
                remarks: '',
            })
            this.$bvModal.show("return-modal");
        },
        returnPRSubmit(modalData) {
            if(this.selectedPRType === 'cancel'){
                this.$store
                    .dispatch("pr/CancelPr", {
                        id: modalData.id,
                        body: modalData.remarks
                    })
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = -1;
                        let copyData = {};
                        if(this.tabModel == 0){
                            index = this.pendingPRs.findIndex(x => x.id == modalData.id)
                            copyData = JSON.parse(JSON.stringify(this.pendingPRs[index]));
                            this.pendingPRs.splice(index, 1);
                        }else if(this.tabModel == 1){
                            index = this.approvedPRs.findIndex(x => x.id == modalData.id)
                            copyData = JSON.parse(JSON.stringify(this.approvedPRs[index]));
                            this.approvedPRs.splice(index, 1);
                        }else if(this.tabModel == 2){
                            index = this.submittedPRs.findIndex(x => x.id == modalData.id)
                            copyData = JSON.parse(JSON.stringify(this.submittedPRs[index]));
                            this.submittedPRs.splice(index, 1);
                        }
                        this.cancelledPRs.push(copyData);
                        this.showToast("Successfully cancelled", "success");
                        this.$bvModal.hide("return-modal");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }else{
                this.$store
                    .dispatch("pr/ReturnPr", modalData)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        if(this.tabModel == 0){
                            let index = this.pendingPRs.findIndex(x => x.id == modalData.id)
                            this.pendingPRs.splice(index, 1);
                        } else if(this.tabModel == 1) {
                            let index = this.submittedPRs.findIndex(x => x.id == modalData.id)
                            this.submittedPRs.splice(index, 1);
                        } else if(this.tabModel == 2) {
                            let index = this.approvedPRs.findIndex(x => x.id == modalData.id)
                            this.approvedPRs.splice(index, 1);
                        }
                        this.showToast("Successfully returned", "success");
                        this.$bvModal.hide("return-modal");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
            
        },
        async approvePR(row){
            if(row.unGroupedItems.length == 0){
                await this.$store
                    .dispatch("pritem/GetPrItems", row.id)
                    .then((res) => {
                        row.unGroupedItems = res.data;
                    })
                    .catch((err) => {
                        return this.showToast("Something went wrong! - getting PR Items", "error");
                    });
            }
            let errorCart = [];
            row.unGroupedItems.forEach((x) => {
                if(x.realigned){
                    errorCart.push(x);
                }
            });
            if(errorCart.length > 0){
                return this.showToast(`${errorCart[0].apiResource.itemName} was included in item modification. Please remove it from cart.`, "warning");
            }
            this.$refs.approvePR.updateData({
                id: row.id,
                bacSettingId: "",
                bacSetting: null,
                modeOfProcurementId: "",
            });
            this.$bvModal.show("approve-modal");
        },
        async approvePRSubmit(modalData){
            await this.$store
                .dispatch("pr/ApprovePr", {
                    id: modalData.id,
                    bacSettingId: modalData.bacSettingId,
                    modeOfProcurementId: modalData.modeOfProcurementId
                })
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    let index = this.pendingPRs.findIndex(x => x.id == modalData.id)
                    let row = JSON.parse(JSON.stringify(this.pendingPRs[index]));
                    this.pendingPRs.splice(index, 1);
                    row.showDetails = false;
                    row.modeOfProcurementId = modalData.modeOfProcurementId;
                    this.approvedPRs.push(row);
                    this.$bvModal.hide("approve-modal");
                    this.showToast("PR Approved!", "success");
                })
                .catch((err) => {
                    console.log(err);
                    this.showToast("Something went wrong! - approving PR", "error");
                });
        },
        returnedToPending(row){
            this.pendingPRs.push(row);
        },
        async getAttachmentBacRes(id){
            this.$refs.attachmentModal.setUploadOpt({
                type: "PR BAC Res",
                placement: "left",
                folder: "Procurement",
            });
            this.$bvModal.show("upload-attachment-modal");
            await this.$refs.attachmentModal.getData(id);
        },
        async printBacRes(id){
            this.$refs.printOpt.putOptions({
                apiUrl: "api/Report/Procurement/BacRes",
                routeVariables: [id],
            });
            this.$bvModal.show("print-options-modal");
        },
        updateBACMember({row, parent}){
            this.employeeType = "BAC";  
            this.selectedBACMember = row;
            this.selectedPR = parent;
            this.$refs.empModal.getSingleSelection();
            this.$bvModal.show('employee-modal');
        },
        dropSingleEmployee(e) {
            if(this.employeeType === 'endUser'){
                this.pr.endUserId = e.applicationUser.id;
                this.pr.endUser = e.firstName + ' ' + e.lastName;
                this.pr.endUserPosition = e.position;   
            }else if(this.employeeType === 'technicalUser'){
                this.pr.technicalUserId = e.applicationUser.id;
                this.pr.technicalUser = e.firstName + ' ' + e.lastName;
            }else{
                this.$swal.fire({
                    title: "Are you sure?",
                    text: "You want to change BAC Member?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Yes, change it!",
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        this.pageLoader(true);
                        let data = {
                            id: this.selectedBACMember.id,
                            applicationUserId: e.applicationUser.id,
                        };
                        await this.$store.dispatch('prresolutionmember/ChangeBACMember', data).then(res => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, 'error');
                            }
                            this.selectedBACMember.applicationUser = e.applicationUser;
                            this.showToast('Successfully changed!', 'success');
                        }).catch(err => {
                            this.showToast('Something went wrong!', 'error');
                        });
                        this.pageLoader(false);
                    }
                });
            }
        },
        async submitToRFQ(row){
            if(row.unGroupedItems.length == 0){
                await this.$store
                    .dispatch("pritem/GetPrItems", row.id)
                    .then((res) => {
                        if(res.data.error){
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        row.unGroupedItems = res.data;
                    })
                    .catch((err) => {
                        return this.showToast(
                            "Something went wrong! - getting PR Items",
                            "error"
                        );
                    });
            }
            let errorCart = [];
            row.unGroupedItems.forEach((x) => {
                if(x.realigned){
                    errorCart.push(x);
                }
            });
            if(errorCart.length > 0){
                return this.showToast(`${errorCart[0].apiResource.itemName} was included in item modification. Please remove it from cart.`, "warning");
            }
            let index = this.approvedPRs.findIndex(x => x.id == row.id);
            this.$swal.fire({
                title: "Are you sure?",
                text: "You want to submit this PR to RFQ?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, submit it!",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.$store
                        .dispatch("pr/SubmitPr", row.id)
                        .then(async (res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            this.submittedPRs.push(this.approvedPRs[index]);
                            this.approvedPRs.splice(index, 1);
                            this.showToast("PR Submitted to RFQ!", "success");
                        })
                        .catch((err) => {
                            this.showToast(
                                "Something went wrong! - submitting PR to RFQ",
                                "error"
                            );
                        });
                }
            });
        },
        selectUser(x, type){
            this.pr = x;
            this.employeeType = type;
            this.$refs.empModal.getSingleSelection();
            this.$bvModal.show('employee-modal');
        },
        cancelPR(row){
            this.selectedPRType = 'cancel';
            this.$refs.returnPR.updateData({
                id: row.id,
                remarks: '',
            })
            this.$bvModal.show("return-modal");
        },
        moveToCampus(pr, type){
            this.selectedPR = pr;
            this.selectedPRType = type;
            this.$bvModal.show('move-campus-modal');
            this.$refs.moveCampusModal.getData();
        },
        moveCampusSubmit(campusId){
            this.$store
                .dispatch("pr/MoveToCampus", { id: this.selectedPR.id, campusId })
                .then(async (res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    if(this.selectedPRType === 'pending'){
                        let index = this.pendingPRs.findIndex(x => x.id == this.selectedPR.id)
                        this.pendingPRs.splice(index, 1);
                    }else if(this.selectedPRType === 'approved'){
                        let index = this.approvedPRs.findIndex(x => x.id == this.selectedPR.id)
                        this.approvedPRs.splice(index, 1);
                    }else if(this.selectedPRType === 'submitted'){
                        let index = this.submittedPRs.findIndex(x => x.id == this.selectedPR.id)
                        this.submittedPRs.splice(index, 1);
                    }else if(this.selectedPRType === 'cancelled'){
                        let index = this.cancelledPRs.findIndex(x => x.id == this.selectedPR.id)
                        this.cancelledPRs.splice(index, 1);
                    }
                    this.$bvModal.hide('move-campus-modal');
                    this.showToast("PR moved to campus successfully!", "success");
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong! - moving PR to campus",
                        "error"
                    );
                });
        },
    },
};
</script>
<template>
    <Layout @changeCycle="changeData($event, $store.state.data.selectedCampus.id)" @changeCampus="changeData($store.state.data.cycle, $event.id)">
        <PageHeader :title="title" :items="items" />
        <b-tabs
            nav-class="nav-tabs-custom"
            content-class="pt-3 pb-3 text-muted"
            v-model="tabModel"
        >
            <b-tab>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Pending Purchase Request</span>
                </template>
                <PRList 
                    type="pending"
                    :prs="pendingPRs"
                    :loading="loading"
                    :managePR="managePR"
                    @updateResource="updateResource($event.data, $event.type, $event.pr)" 
                    @printPR="printPR"
                    @changePRNo="changePRNo"
                    @updateCycle="updateCycle($event.row, $event.type)"
                    @updatePRDescription="updatePRDescription($event.row, $event.type)"
                    @getPRLogs="getPRLogs"
                    @returnPR="returnPRFunc"
                    @approvePR="approvePR"
                    @cancelPR="cancelPR"
                    @moveToCampus="moveToCampus($event, 'pending')"
                />
            </b-tab>
            <b-tab>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Approved Purchase Request</span>
                </template>
                <PRList 
                    type="approved"
                    :prs="approvedPRs"
                    :loading="loading"
                    :managePR="managePR"
                    :mop="mop"
                    @updateResource="updateResource($event.data, $event.type, $event.pr)" 
                    @printPR="printPR"
                    @changePRNo="changePRNo"
                    @updateCycle="updateCycle($event.row, $event.type)"
                    @updatePRDescription="updatePRDescription($event.row, $event.type)"
                    @getPRLogs="getPRLogs"
                    @returnedToPending="returnedToPending"
                    @getAttachmentBacRes="getAttachmentBacRes"
                    @printBacRes="printBacRes"
                    @updateBACMember="updateBACMember"
                    @submitToRFQ="submitToRFQ"
                    @selectUser="selectUser($event.x, $event.type)"
                    @cancelPR="cancelPR"
                    @moveToCampus="moveToCampus($event, 'approved')"
                />
            </b-tab>
            <b-tab>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Submitted to Bids/RFQ</span>
                </template>
                <PRList 
                    type="submitted"
                    :prs="submittedPRs"
                    :loading="loading"
                    :managePR="managePR"
                    :mop="mop"
                    @updateResource="updateResource($event.data, $event.type, $event.pr)" 
                    @printPR="printPR"
                    @changePRNo="changePRNo"
                    @updateCycle="updateCycle($event.row, $event.type)"
                    @updatePRDescription="updatePRDescription($event.row, $event.type)"
                    @getPRLogs="getPRLogs"
                    @returnedToPending="returnedToPending"
                    @getAttachmentBacRes="getAttachmentBacRes"
                    @printBacRes="printBacRes"
                    @updateBACMember="updateBACMember"
                    @selectUser="selectUser($event.x, $event.type)"
                    @cancelPR="cancelPR"
                    @moveToCampus="moveToCampus($event, 'submitted')"
                />
            </b-tab>
             <b-tab>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Cancelled Purchase Request</span>
                </template>
                <PRList 
                    type="cancelled"
                    :prs="cancelledPRs"
                    :loading="loading"
                    :managePR="managePR"
                    :mop="mop"
                    @updateResource="updateResource($event.data, $event.type, $event.pr)" 
                    @printPR="printPR"
                    @changePRNo="changePRNo"
                    @updateCycle="updateCycle($event.row, $event.type)"
                    @updatePRDescription="updatePRDescription($event.row, $event.type)"
                    @getPRLogs="getPRLogs"
                    @returnToPending="returnedToPending"
                    @moveToCampus="moveToCampus($event, 'cancelled')"
                />
             </b-tab>
        </b-tabs>
        <ReturnPR ref="returnPR" :isReturn="selectedPRType === 'return'" @submit="returnPRSubmit"/>
        <ApprovePR 
            :mop="mop"
            :bacSettings="bacSettings"
            ref="approvePR" 
            @submit="approvePRSubmit"
        />
        <PrLogs ref="prLogs" />
        <PRDescModal ref="prDescModal" @submit="updatePRDescriptionSubmit"/>
        <TransferCycleModal ref="transferCycleModal" @transferCycle="transferCycleSubmit" />
        <MoveCampusModal ref="moveCampusModal" @moveCampus="moveCampusSubmit" />
        <PrintOptions ref="printOpt" />
        <PRNumberModal ref="prNumberModal" @prNumberChanged="updatePRNumber"/>
        <AttachmentModal
            :wActions="true"
            title="Purchase Request BAC Attachments"
            ref="attachmentModal"
        />
        <EmployeeModal ref="empModal" @dropData="dropSingleEmployee" />
        <ItemUpdate ref="itemUpdate" @dropData="updateDescriptionSubmit" :fromProcurement="true"/>
    </Layout>
</template>